import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import theme from '../../src/theme';
import "@fontsource/fira-code/500.css";
import { CssBaseline, ThemeProvider} from '@mui/material';

export default function TopLayout(props) {
  return (
    <React.Fragment>
      <Helmet>
        <title>pabs.dev</title>
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
        <link
          href="https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        {props.children}
      </ThemeProvider>
    </React.Fragment>
  );
}

TopLayout.propTypes = {
  children: PropTypes.node,
};
